import styled from 'styled-components';

export const WebFooterStyle = styled.div`
  background: #FFFFFF;
  .content {
    padding-top: 60px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 94px;
    .logo {
      width: 131px;
      height: 32px;
    }
    .enter-list {
      li {
        padding-bottom: 20px;
        a {
          display: block;
          font-size: 14px;
          color: #333333;
          white-space: nowrap;
        }
      }
    }
    .contact-list {
      li {
        padding-bottom: 20px;
        font-size: 14px;
      }
    }
    .qr-box {
      width: 120px;
      text-align: center;
      color: #333333;
      font-size: 14px;
      img {
        height: 120px;
        width: 120px;
      }
    }
  }
  .bottom-copyright {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: rgba(102, 102, 102, 0.5);
    padding-bottom: 40px;
  }
`